import React from "react";
import { FaDownload } from "react-icons/fa";
import logoIBFMO from "../../assets/logoIBFMO.png";

const CartaPreview = ({ data, fechaInicio, fechaFin }) => {
  const fecha = new Date().toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });

  // 🔥 DESCARGA INDIVIDUAL
  const descargarPDF = async () => {
    try {
      if (!data?.id_miembro) {
        alert("No hay información del miembro");
        return;
      }

      const res = await fetch("/api/cartas/individual", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_miembro: data.id_miembro,
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin
        })
      });

      if (!res.ok) throw new Error("Error al generar PDF");

      const blob = await res.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      const nombreArchivo = `Carta_${data?.nombre || ""}_${data?.paterno || ""}`
        .replace(/\s+/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "");

      link.href = url;
      link.download = `${nombreArchivo}.pdf`;
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("Error al descargar PDF");
    }
  };

  if (!data) return null;

  return (
   <div className="w-[794px] min-h-[1123px] bg-white shadow-xl mx-auto p-10 font-serif relative flex flex-col">

      {/* BOTÓN DESCARGA */}
      <div className="flex justify-end mb-4">
        <button
          onClick={descargarPDF}
          className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition"
        >
          <FaDownload className="text-xs" /> Descargar PDF
        </button>
      </div>

      {/* ICONO */}
     <div className="flex justify-center mb-4">
        <img
            src={logoIBFMO}
            alt="Logo Iglesia"
            className="h-32 object-contain"
        />
        </div>

      {/* TITULO */}
      <h2 className="text-center text-xl font-semibold tracking-widest mb-6">
        CARTA DE AGRADECIMIENTO
      </h2>

      {/* HEADER */}
     <div className="mb-6">
        <div className="flex justify-end">
    <span className="text-sm text-gray-700">
      {fecha}
    </span>
  </div>
  
  <div className="mb-4">
    <p className="text-justify leading-relaxed">
      Estimado(a) {data?.nombre || ""} {data?.paterno || ""} {data?.materno || ""}
    </p>
  </div>

  

</div>

      {/* TEXTO */}
      
       
      <p className="mb-4 text-justify leading-relaxed">
        La presente es para darle gracias a Dios y a usted, por la fidelidad en los diezmos, ofrendas y misiones con los cuales usted ha contribuido generosamente para el crecimiento en la obra de nuestro Señor Jesucristo.
        </p>

        <p className="mb-4 text-justify leading-relaxed">
        Le compartimos que durante este año usted ha contribuido en diezmos y ofrendas con la cantidad que se desglosa a continuación:
        </p>
    
      {/* TABLA */}
      <div className="border mt-4 rounded">

        <div className="flex justify-between bg-slate-100 font-semibold px-3 py-2">
          <span>Concepto</span>
          <span>Total</span>
        </div>

        {(data?.detalle || []).map((d, i) => (
          <div key={i} className="flex justify-between px-3 py-2 border-t">
            <span className="capitalize">{d?.tipo || ""}</span>
            <span>${Number(d?.total || 0).toFixed(2)}</span>
          </div>
        ))}

        <div className="flex justify-between px-3 py-2 border-t font-bold bg-slate-50">
          <span>Total</span>
          <span>${Number(data?.total || 0).toFixed(2)}</span>
        </div>

      </div>

      {/* FOOTER */}
      <p className="mt-4 text-justify leading-relaxed">
        Le animamos a que este próximo año siga siendo fiel en cada uno de los diezmos y ofrendas.
        </p>

        <p className="mt-4 text-justify leading-relaxed">
        Sin más que agregar, le agradecemos una vez más por su apoyo en cada contribución que sin duda ha sido de gran bendición para la obra.
        </p>

        <p className="mt-4 text-justify leading-relaxed font-semibold">
        2 Corintios 9:6-7: "Pero esto digo: El que siembra escasamente, también segará escasamente; y el que siembra generosamente, generosamente también segará. Cada uno dé como propuso en su corazón: no con tristeza, ni por necesidad, porque Dios ama al dador alegre."
        </p>
      <p className="mt-6">Con aprecio y gratitud,</p>

      <p className="mt-6">
        Atentamente,<br />
        <b>Pastor Arnulfo Olivo Flores</b>
        </p>

        {/* FOOTER */}
<div className="mt-10 border-t pt-4 text-sm text-slate-600">

  <div className="flex justify-between items-start gap-4">

    {/* REDES / CONTACTO */}
    <div className="space-y-2">

      <div className="flex items-center gap-2">
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
          className="w-5 h-5"
          alt="facebook"
        />
        <span>Iglesia Bautista Fundamental Monte de los Olivos</span>
      </div>

      <div className="flex items-center gap-2">
        <img
          src="https://cdn-icons-png.flaticon.com/512/732/732200.png"
          className="w-5 h-5"
          alt="email"
        />
        <span>ibfimontedelosolivos@gmail.com</span>
      </div>

    </div>

    {/* DIRECCIÓN */}
    <div className="flex items-start gap-2 max-w-[280px]">

      <img
        src="https://cdn-icons-png.flaticon.com/512/684/684908.png"
        className="w-5 h-5 mt-1"
        alt="location"
      />

      <span>
        Calle 9 de Agosto #500, Salvador Chávez Mora, C.P. 67268
        Juárez, Nuevo León
      </span>

    </div>

  </div>

</div>

    </div>

    
  );
};

export default CartaPreview;